import onCoordinatesStepStatus from "./on-coordinates-step-status";
import onIntervalStepStatus from "./on-interval-step-status";
import getEqualArrayItems from "./on-property-percents/get-equal-array-items";
import onOffsetHooks from "./on-property-percents/on-offset-hooks";
import onStatusCycle from "./percents/on-status-cycle";

/**
 *
 * @param {TemporaryDataProps} data
 * @param {StepProps | TimelineMapProps} step
 * @param {Number} percents
 * @param {Boolean} enter
 * @param {Boolean} coords
 * @param {Number} number Step number
 */
const onStepStatus = (data, step, percents, enter, coords, number) => {
  if (coords) {
    onCoordinatesStepStatus(data, step, number);
  } else {
    onIntervalStepStatus(data, step, percents, enter);
  }
};

export default onStepStatus;
